import React from "react";
import {Alert, Button, Space} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {RootStoreContext} from "../../../../../stores/root/root";
import {Price} from "../../../../core/commons/price/price";
import {Amount} from "../../../../../models/amount/amount";
import {useRequiredLayers} from "../../../../../utils/context";
import {RootControllersContext} from "../../../../../controllers/root/root.controllers";

interface InvoiceValues {
    id: number;
    paid: boolean;
    allowToPay: boolean;
    grandTotal: Amount;
}

interface InvoicePayButtonProps {
    invoice: InvoiceValues;
}

export const InvoicePayWidget: React.FC<InvoicePayButtonProps> = ({invoice}) => {

    const {store: {authStore}, controller: {loginController}} = useRequiredLayers(RootStoreContext, RootControllersContext)

    if (!authStore.lz.py) {
        return null;
    }

    return (
        <>{!invoice.paid ? (<>
                {invoice.allowToPay ? (
                    <Space style={{justifyContent: "end"}} direction={"horizontal"}>
                        <a href={loginController.generateUri("/api/v3/payments/invoice/" + invoice.id)} target={"_blank"} rel={"noreferrer"}>
                            <Button
                                icon={<FontAwesomeIcon icon={["fas", "credit-card"]}/>}
                                type={"primary"}
                            >
                                <span style={{padding: "0 3px 0 10px"}}>Pay</span>
                                <Price value={invoice.grandTotal}/>
                            </Button>
                        </a>
                    </Space>
                ) : (
                    <Alert
                        showIcon
                        description={"Payment will be available only after the goods have been shipped"}
                        message={"Thanks for your order!"}
                    />
                )}
            </>
        ) : null}
        </>
    )
}